import React, { Component } from 'react';
import Page from '../../components/page';
import { FullHeightLayout, SimpleLayout } from '../../components/layout';
import NotFound from '../../components/not-found';
import AppLoaded from '../../components/app-loaded';
import forDevice from '../../hoc/for-device';

const Layout = forDevice(FullHeightLayout, SimpleLayout);

export class NotFoundPage extends Component {
  render() {
    return (
      <Page noSpacing data-hook="not-found-page">
        <Layout>
          <NotFound />
        </Layout>
        <AppLoaded />
      </Page>
    );
  }
}

export default NotFoundPage;
